// Wonder Passport — persistent record of which world wonders a kid
// has tapped. Powers the sticker stamp animation on the Wonders strip
// and unlocks the "World Explorer" badge at 12/12.
//
// localStorage schema:
//   we_wonder_passport_v1 = ["eiffel", "pyramids", ...]

import { WONDERS } from "@/data/wonders";

const KEY = "we_wonder_passport_v1";

export function loadPassport() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function stampWonder(slug) {
  const list = loadPassport();
  if (list.includes(slug)) return { list, added: false };
  const next = [...list, slug];
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("we-wonder-stamped", { detail: { slug, count: next.length } }));
  return { list: next, added: true };
}

export function hasWonder(slug) {
  return loadPassport().includes(slug);
}

export function totalWonders() {
  return WONDERS.length;
}

export function passportComplete() {
  return loadPassport().length >= WONDERS.length;
}
